import { Icon, symbolName } from './Icon'

type ChevronDownIconProps = Readonly<{
  size?: number
  color?: string
}>

export function ChevronDownIcon({
  size = 12,
  color = '#777777',
}: ChevronDownIconProps) {
  return (
    <Icon
      name={symbolName('chevron.down', 'expand_more')}
      size={size}
      color={color}
    />
  )
}
